<template>
  <el-dialog
    :title="modalTitle"
    :visible.sync="visible"
    width="800px"
    center
    :close-on-click-modal="true"
    @close="close"
    class="silo-transfer-dialog"
  >
    <el-card shadow="always">
      <!-- SILO INFORMATION -->
      <div class="gridTemplate-five">
        <p class="dialog-p-subtitle">{{ i18nValues['silo'] }}</p>
        <el-form-item :label="i18nValues['name']">
          <span style="font-weight: lighter; font-size: 12px;">{{ siloInfo.name }}</span>
        </el-form-item>
        <el-form-item label="Brand" v-if="siloInfo.product">
          <span style="font-weight: lighter; font-size: 12px;">{{ siloInfo.product.brand }}</span>
        </el-form-item>
        <el-form-item :label="i18nValues['quantityInKg']">
          <span style="font-weight: lighter; font-size: 12px;">{{ siloInfo.usedKg }}</span>
        </el-form-item>
      </div>

      <!-- DYNAMIC INPUT ROWS: Each row has 3 inputs -->
      <p v-if="!siloInfo.pending" class="dialog-p-subtitle">{{ i18nValues['destination'] }}</p>
      <p v-if="siloInfo.pending" class="dialog-p-subtitle">{{ i18nValues['comment'] }}</p>

      <div v-if="siloInfo.type !== 'discard'" class="input-row" >
        <el-form
          ref="formTransfer"
          :model="data"
          :rules="formRules"
          inline
        >

          <el-form-item
            v-if="!siloInfo.pending"
            :label="i18nValues['siloDestination']"
            prop="destination"
          >
            <el-select v-model="selectedDestination" :popper-append-to-body="false" placeholder="">
              <el-option
                v-for="item in DestinationList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="i18nValues['comment']" prop="comment" class="form-item">
            <el-input v-model="data.comment" />
          </el-form-item>
        </el-form>
      </div>

      <div v-else v-for="(row, index) in inputRows" :key="index" class="input-row">
        <!-- Quantity Input -->
        <el-form-item :label="i18nValues['quantity']" class="form-item" v-if="siloInfo.type === 'discard' && !siloInfo.pending">
          <el-input
            v-model="row.quantity"
            :placeholder="i18nValues['quantity']"
            @keypress.native="isNumberWithDecimals($event)"
          ></el-input>
        </el-form-item>
        <!-- Destination Input (if applicable) -->
        <el-form-item
          v-if="!siloInfo.pending"
          :label="i18nValues['siloDestination']"
          class="form-item"
        >
          <el-select v-model="row.destination" :popper-append-to-body="false" placeholder="">
            <el-option
              v-for="item in DestinationList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- Refer-->
        <el-form-item :label="i18nValues['refer']" class="form-item">
          <el-input
            v-model="row.refer"
            :placeholder="i18nValues['refer']"
          ></el-input>
        </el-form-item>
        <!-- Comment Input -->
        <el-form-item :label="i18nValues['comment']" class="form-item">
          <el-input
            v-model="row.comment"
            :placeholder="i18nValues['comment']"
          ></el-input>
        </el-form-item>
        <!-- Remove -->
        <div class="form-item">
          <el-button
            v-if="siloInfo.type === 'discard' && inputRows.length > 1"
            class="text-danger"
            style="margin-top: 30px;"
            icon="fas fa-times"
            size="small"
            :title="i18nValues['remove']"
            @click="removeInput(index)"
          ></el-button>
        </div>
      </div>

      <!-- Button to add a new input row -->
      <div class="button-style-add">
        <el-button
          v-if="siloInfo.type === 'discard' && !siloInfo.pending"
          @click="addInput"
          icon="fas fa-plus"
          id="searchButton"
          size="small"
          style="margin-top: 15px;"
          class="btn-primary custom-button"
        >
          {{ i18nValues['add'] }}
        </el-button>
      </div>

      <!-- OPTIONAL: PRODUCTS Table if needed -->
      <div v-if="siloInfo.type === 'discard' && !siloInfo.pending">
        <p class="dialog-p-subtitle">{{ i18nValues['products'] }}</p>
        <el-table
          :data="DiscardList"
          style="width: 100%; margin-left: -20px"
          row-key="id"
          class="custom-table table table-hover table-striped"
          :empty-text="i18nValues['noDataAvailable']"
          align="left"
        >
          <el-table-column
            prop="product.brand"
            label="Brand"
            align="left"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="product.name"
            :label="i18nValues['variety']"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="initialQuantity"
            :label="i18nValues['quantity']"
            align="right"
            width="120"
          ></el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- BUTTONS -->
    <div class="button-style-save">
      <el-button
        v-if="!siloInfo.pending"
        icon="fas fa-check"
        :loading="loading"
        size="small"
        class="btn-primary"
        @click="save"
      >
        {{ i18nValues["empty"] }}
      </el-button>
      <el-button
        v-else
        icon="fas fa-check"
        :loading="loading"
        size="small"
        class="btn-primary"
        @click="save"
      >
        {{ i18nValues["confirm"] }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { get } from "vuex-pathify";
export default {
  name: "SiloTransferModal",
  computed: {
    loading: get("silo/loading"),
    globalFieldSite: get("globalFieldSite"),
    modalTitle() {
      return this.siloInfo && this.siloInfo.pending
        ? this.i18nValues["clearSiloMessage"]
        : this.i18nValues["clearSilo"];
    },
    modalActionText() {
      if (
        this.siloInfo.type === "discard" &&
        this.data.partialQuantity &&
        this.data.partialQuantity < this.siloInfo.usedKg
      ) {
        return this.i18nValues["partialRemove"];
      }
      return this.siloInfo.pending
        ? this.i18nValues["confirm"]
        : this.i18nValues["empty"];
    },
    formRules() {
      if (this.siloInfo && this.siloInfo.type !== "discard") {
        return {
          comment: [
            { required: true, message: this.i18nValues["required"], trigger: "blur" }
          ]
        };
      }
      return {};
    }
  },
  props: ["visible", "siloInfo"],
  data() {
    return {
      data: {
        comment: "",
        partialQuantity: null
      },
      selectedDestination: null,
      // New array to hold each input row.
      inputRows: [{}],
      DestinationList: [
        { id: 0, value: "Cargill Puerto", label: "Cargill Puerto" },
        { id: 1, value: "Samsa Semillas", label: "Samsa Semillas" },
        { id: 2, value: "Cargill Rojas", label: "Cargill Rojas" }
      ],
      DiscardList: [],
      ProductList: [],
      showDestDropdown: false,
      rowDropdownIndex: -1
    };
  },
  watch: {
    siloInfo: {
      handler(newValue) {
        if (newValue && newValue.type === "discard") {
          this.retrieveDiscardSiloProducts();
        }
      },
      immediate: true
    }
  },
  methods: {
    addInput() {
      this.inputRows.push({
        quantity: "",
        destination: null,
        comment: ""
      });
    },
    removeInput(index) {
      this.inputRows.splice(index, 1);
    },
    toggleRowDropdown(index) {
      this.rowDropdownIndex = this.rowDropdownIndex === index ? -1 : index;
    },
    closeRowDropdown(index) {
      if (this.rowDropdownIndex === index) this.rowDropdownIndex = -1;
    },
    retrieveDiscardSiloProducts() {
      let filter = {
        id: this.siloInfo.id,
        fieldSiteId: this.globalFieldSite.id
      };
      this.$store
        .dispatch("silo/retrieveDiscardSiloProducts", filter)
        .then(res => {
          this.DiscardList = res;
          this.DiscardList.forEach(item => {
            if (item.product != null) {
              this.ProductList.push(item.product);
            }
          });
          this.DiscardList = res.reverse()
        });
    },
    close() {
      this.data = { comment: "", partialQuantity: null };
      this.selectedDestination = null;
      this.inputRows = [{}];
      this.showDestDropdown = false;
      this.rowDropdownIndex = -1;
      this.$emit("update:visible", false);
      if (this.siloInfo.type != 'discard' && !this.siloInfo.edited) {
        this.$message({
          type: "info",
          message: this.siloInfo.pending
            ? this.i18nValues["confirmClearCancel"]
            : this.i18nValues["ClearCancel"]
        });
      }
    },
    save() {
      if (this.siloInfo.type !== "discard") {
        this.$refs.formTransfer.validate(valid => {
          if (valid) {
            const siloToSave = {
              silo: { id: this.siloInfo.id },
              user: this.user ? this.user.name : "unknown",
              comment: this.data.comment,
              refer: this.data.refer,
              destination: this.selectedDestination,
              fieldSite: { id: this.globalFieldSite ? this.globalFieldSite.id : null }
            };

            if (!this.siloInfo.pending) {
              this.clear(siloToSave);
            } else {
              this.confirmClear(siloToSave);
            }
          }
        });
      }
      else if (this.siloInfo.type === "discard" && !this.siloInfo.pending) {
        const totalRemoval = this.inputRows.reduce((sum, row) => {
          return sum + (parseFloat(row.quantity) || 0);
        }, 0);

        if (totalRemoval > this.siloInfo.usedKg) {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["exceededAmount"],
            position: "bottom-right"
          });
          return;
        }

        const trxList = this.inputRows.map(row => ({
          silo: { id: this.siloInfo.id },
          user: this.user ? this.user.name : "unknown",
          comment: row.comment,
          destination: row.destination,
          refer: row.refer,
          fieldSite: { id: this.globalFieldSite ? this.globalFieldSite.id : null },
          removalQuantity: parseFloat(row.quantity)
        }));

        this.$store.dispatch("silo/partialClear", trxList).then(res => {
          if (res.status === "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["SiloClear"],
              position: "bottom-right"
            });
            this.$emit("updateSilos");
            this.$emit("update:visible", false);
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: res.statusDescription,
              position: "bottom-right"
            });
          }
        });
      }
      else {
        const siloToSave = {
          silo: { id: this.siloInfo.id },
          user: this.user ? this.user.name : "unknown",
          comment: this.data.comment,
          destination: this.selectedDestination,
          fieldSite: { id: this.globalFieldSite ? this.globalFieldSite.id : null }
        };
        this.confirmClear(siloToSave);
      }
    },

    clear(siloToSave) {
      this.$store.dispatch("silo/clear", siloToSave).then(res => {
        if (res.status === "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["SiloClearPending"],
            position: "bottom-right"
          });
          this.siloInfo.edited = true;
          this.$emit("updateSilos");
          this.$emit("update:visible", false);
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: res.statusDescription,
            position: "bottom-right"
          });
        }
      });
    },
    confirmClear(siloToSave) {
      this.$store.dispatch("silo/confirmClear", siloToSave).then(res => {
        if (res.status === "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["SiloClear"],
            position: "bottom-right"
          });
          this.siloInfo.edited = true;
          this.$emit("updateSilos");
          this.close();
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["SiloClearError"],
            position: "bottom-right"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.button-style-save {
  display: flex;
  justify-content: flex-end;
  margin-right: 15px;
  margin-top: 15px;
}
.native-select,
.custom-select-wrapper {
  position: relative;
  width: 145px;
}
.custom-select-input {
  height: 28px;
  padding: 0 25px 0 10px;
  font-size: 13px;
  font-family: inherit;
  color: #606266;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.custom-select-input:hover {
  border-color: #c0c4cc;
}
.custom-select-input.is-focus {
  border-color: #409eff;
}
.custom-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-select-placeholder {
  flex: 1;
  color: #c0c4cc;
}
.custom-select-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%) rotate(0deg);
  transition: transform 0.3s;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #c0c4cc;
}
.custom-select-arrow.is-reverse {
  transform: translateY(-50%) rotate(180deg);
}
.custom-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 4px 0 0;
  padding: 6px 0;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
}
.custom-select-option {
  padding: 0 20px;
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-option:hover {
  background-color: #f5f7fa;
}
.custom-select-option.selected {
  color: #409eff;
  font-weight: 700;
}
</style>

<style>
.silo-transfer-dialog .el-dialog__wrapper {
  overflow: visible !important;
}
.silo-transfer-dialog .el-dialog__body {
  overflow: visible;
}
.silo-transfer-dialog .el-card__body {
  overflow: visible;
  padding-bottom: 40px;
}
.silo-transfer-dialog .el-select-dropdown {
  position: absolute !important;
}
.custom-table {
  background-color: transparent !important;
}
.custom-table .el-table th,
.custom-table .el-table td {
  background-color: transparent !important;
}
/* Adjust input row spacing */
.input-row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
}
/* Optional: add spacing between form items if needed */
.form-item {
  margin-right: 20px;
}
</style>
